import { cx } from "@emotion/css";
import styled from "@emotion/styled";
import { useTranslation } from "react-i18next";
import { htmlFormatter } from "src/formatters/htmlFormatter";
import { getAppConfig } from "src/hooks/useAppConfig";
import { useFontSize } from "src/hooks/useFontSize";
import { useNoCopy } from "src/hooks/useNoCopy";

import isMobile from "../../../../../helpers/isMobile";
import Gallery from "../../../Images/Gallery";
import CommentsContent from "./CommentsContent";

const CommentImageContainer = styled.div`
  display: flex;
  color: rgb(123, 142, 157);
  margin-top: 4px;
`;

const SubcommentsSection = styled.div`
  padding-left: 12px;
  margin-left: 8px;
  border-left: 1px solid #f9f4fa;

  > div > ul {
    padding: 0;
  }
`;

export const Comment = ({
	comment,
	isReply,
	setIsReply,
	onAddComment,
	onRemoveComment,
	onToggleLike,
}) => {
	const appConfig = getAppConfig();
	const { onCopy, noCopyClassName } = useNoCopy({
		config: appConfig.copyContentSettings.comments,
	});
	const { fontSizeClass } = useFontSize();
	const { t } = useTranslation();

	const renderSubComments = () => {
		if (!comment.subComments) {
			return null;
		}

		return (
			<CommentsContent
				comments={comment.subComments}
				isActive={isReply}
				parentComment={comment}
				placeholder={t("exam.comments.replyComment")}
				onSuccess={() => setIsReply(false)}
				onAddComment={onAddComment}
				onRemoveComment={onRemoveComment}
				onToggleLike={onToggleLike}
			/>
		);
	};

	const renderCommentImage = () => {
		if (!comment.images) {
			return null;
		}

		return (
			<CommentImageContainer>
				<Gallery
					images={comment.images.map((image) => {
						return {
							image: image.url,
							title: image.source.source,
						};
					})}
					maxImages={isMobile() ? 5 : null}
				/>
			</CommentImageContainer>
		);
	};

	return (
		<div className="flex flex-col">
			<div className="ws-pre-wrap flex flex-col">
				<div
					onCopy={(e) =>
						onCopy(e, { questionId: comment.questionId, type: "Comment" })
					}
					className={cx(
						"m-0 flex-1 ww-break-word wb-break-word text-black font-light",
						noCopyClassName,
						fontSizeClass,
					)}
				>
					{htmlFormatter(comment.comment)}
				</div>
				{renderCommentImage()}
			</div>
			<SubcommentsSection>{renderSubComments()}</SubcommentsSection>
		</div>
	);
};
